module.exports = __webpack_public_path__ + "static/media/user.043113d0.svg";